<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">

$acg-blue: #005cbb;
$acg-light-blue: #2e8be8;
$acg-grey: #666;

//html5 roles
article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section, main {
    display:block;
}

.wrap-box {
    max-width: 1280px;
    padding: 10px;
    border: 1px solid $acg-light-blue;
    margin: 0;
    display:inline-block;
}

p {
    font-size: 1.3em;
    line-height: 1.5;
}

label {
    font-size: 1.3em;
}

button {
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 5px;
    padding-bottom: 5px;

}
.list-item {
    margin-top: 4px;
    margin-bottom: 8px;
    border-bottom: 1px solid #CCC;
}

.menu {
    margin-top: 40px;
}

.widget {
    display: inline-flex;
    flex-flow: column;
    margin: 0;
    flex-grow: 1;

    ul {
        padding: 0;
        list-style: none;
    }

    h4, h5, h6 {
        color: $acg-grey;
    }
}

.half {
    width: 960px;
}

.one-third {
    width: 400px; //320 - padding width
    margin: 0;
    padding: 8px 8px 8px 12px;
    display: inline-block;
}

.two-thirds {
    width: 750px;
    margin: 0;
    padding: 8px 8px 8px 12px;
    display: inline-block;
}

.page {
    min-height: 600px;
    margin-top: 78px;
}

.box {
    margin-bottom: 50px;
}
.site-inner {
    max-width: 1280px;
}

main ul, .sub-menu ul {
    padding: 0;
}

main ul li {
    list-style-type: none;
    font-size: 16px;
}

.widget li, .widget p {
    font-size:1.5em;
}

.sub-menu h4 {
    margin: 0 0 1px;
}
.sub-menu ul li {
    list-style-type: none;
    font-size: 14px;
    line-height: 1.5;
}

textarea{
    max-width: 95%;
}

//From all.css

.layer-page {
    max-width: 1280px;
    margin: 0 auto 20px;
    padding-top: 16px;
    display: flex;
}

.holder {
    max-width: 1280px;
}

.filter-pane {
    max-height: 640px;
    overflow-y: scroll;
    box-sizing: border-box;
}

.full-map-pane {
    padding: 8px 0;
    height: 632px;
    box-sizing: border-box;
    flex-grow: 100;
}

.layer-label {
    margin-left: 2px;
}

li .circle {
    margin-left: 4px;
}

.circle {
    cursor: pointer;
    border-radius: 50%;
    display: inline-block;
}

.info-window {
    border: 1px solid #CCC;
    background-color: #FFF;
    min-height: 15px;
    position: absolute;
    bottom: 16px;
    left: -87px;
    overflow: visible;
    height: auto;
    width: 160px;
    padding: 4px 6px;
    z-index: 20;
    font-size: 12px;
}

.info-window:after, .info-window:before {
	top: 100%;
	left: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
    position: absolute;
    pointer-events: none;
}

.info-window:after {
	border-color: rgba(255, 255, 255, 0);
	border-top-color: #FFF;
	border-width: 10px;
	margin-left: -10px;
}
.info-window:before {
	border-color: rgba(204, 204, 204, 0);
	border-top-color: #CCC;
	border-width: 12px;
	margin-left: -12px;
}


.info-window-close {
    float: right;
    cursor: pointer;
    color: #000;
    padding: 4px;
}

.info-window-close svg {
    fill: #000;
    stroke: #000;
}

h3 {
    margin: 0.3em 0 0.2em;
}

.filter-container {
    margin-bottom: 16px;
}

.filter-header {
    cursor: pointer;
    background-color: #fff;
    background: linear-gradient(#fff, #eee);
    color: $acg-grey;
    font-weight: bold;
    vertical-align: middle;
    border: .5px solid #ddd;
    font-size: 14px;
    padding: 4px 8px;
    border-radius: 4px;
}

.filter-item, .filter-item span {
    padding-top: 4px;
    background-color:#fff;
    color: #000;
    font-weight: normal;
    font-size: 14px;
    line-height: 1.5;
}

.filter-container label {
    font-size: 14px;
    font-weight: bold;
    color: $acg-grey;
    margin-top: 4px;
}

.filter-container input[type=text], .filter-container select {
    box-sizing: border-box;
    width: 100%;
    padding: 4px 8px;
    margin-top: 2px;
    font-size: 14px;
    //color: #666;
}

.filter-container input[type=text] {
    border-radius: 4px;
    border: .5px solid #ddd;
}

.filter-container select {
    //-webkit-appearance: none;
    //-moz-appearance: none;
    //appearance: none;
    background-color: #fff;
    border: .5px solid #ddd;
}

.icon {
    display: inline-block;
    width: 1em;
    height: 1em;
    color: $acg-grey;
    fill: $acg-grey;
    stroke: $acg-grey;
}

.loader-img {
    position: relative;
    bottom: 311px;
    z-index: 10;
    left: 370px;
}

#mobile-menu {
    margin-bottom: 16px;
    font-size: 16px;
}

#page-header {
    margin: 78px 8px 0;
    font-size: 32px;
}

#mobile-menu, #filters-and-settings, #blurb {
    flex: 0 0 auto;
}

@media (max-width: 960px) {
    .filter-pane {
        width: 260px;
    }
}

@media (max-width: 720px) {
    .filter-pane {
        width: 220px;
    }
}

@media (max-width: 600px) {
    .layer-page {
        width: 100%;
        display: block;
    }

    .widget {
        display: block;
    }

    .full-map-pane {
        box-sizing: border-box;
    }

    .filter-pane {
        width: 100%;
    }

    .filter-header {
        padding: 8px;
        text-align: left;
        width: 100%;
        box-sizing: border-box;
    }

    .layer-page {
        border-left: none;
        border-right: none;
        border-bottom: none;
        border-radius: 0;
    }

    .loader-img {
        margin: 0 auto;
        display: block;
        left:0;
    }

    .info-window {
        font-size: 14px;
    }
}

#header {
    background-color: $acg-light-blue;
    height: 50px;
    padding-top: 8px;
    width: 100%;
    position: fixed;
    z-index: 3;
    margin-bottom: 78px;
    top: 0;

    a.logo:visited {
        color: #fff;
    }

    .logo {
        font-size: 2.5em;
        font-family: 'PT Sans', sans-serif;
        text-decoration: none;
        display: inline-block;
        padding-top: 4px;
        color: #fff;
        margin-right: 8px;
    }

    .logo i {
        font-size: 150%;
        vertical-align: text-top;
    }
}

#top-logo {
    display: inline-block;
}

#top-links {
    margin-top: 14px;
    font-size: 14px;
    float: right;
    min-height:  0;
}

#top-links p {
    margin: 0;
    padding: 0;
}

.tab-bar {
    margin-top: 78px;
    padding-left: 12px;
    //border-bottom: 1px solid #005cbb;
}

.tab {
    display: inline-block;
    background-color: $acg-blue;
    padding: 8px 12px;
    margin: 0 4px;
    border-radius: 12px 12px 0 0
}

.tab-label a {
    color: #fff;
    font-size: 16px;
    padding: 0;
}

.tab.active {
    background-color: #fff;
    border: 1px solid $acg-blue;
    border-bottom: none;
    z-index: 2;
    position: relative;
    top: 1px;
}

.tab.active a {
    color: $acg-blue;
    font-weight: bold;
    font-size: 18px;
}

.tab-label a:hover {
    text-decoration: underline;
}

@media (max-width: 780px) {
    nav {
        background-color: #fff;
    }
}

@media (max-width: 650px) {
    #header {
        position: static;
        padding: 0 8px 8px;
        box-sizing: border-box;
        height: auto;
        margin-bottom: 0;
    }

    #page-header {
        margin-top: 12px;
    }

    #top-links {
        padding: 0;
        margin-top: -8px;
        display: block;
        float: none;
        text-align: center;
    }

    #top-links p a:first-of-type, #top-links p b:first-of-type {
        display: inline;
    }

    .tab-bar {
        margin-top: 28px;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue